<template>
  <div :class="`toast toast--${message.status}`">
    <div class="toast__icon">
      <component :is="toastStatusIcon[message.status]" />
    </div>
    <div class="toast__text typo-small-title">
      {{ message.message }}
    </div>
  </div>
</template>

<script setup>
import SuccessIcon from '../../images/toast-success-icon.svg';
import WarningIcon from '../../images/toast-warning-icon.svg';
import ErrorIcon from '../../images/toast-error-icon.svg';

defineProps({
  message: { type: Object, required: true},
});

const toastStatusIcon = {
  success: SuccessIcon,
  warning: WarningIcon,
  error: ErrorIcon,
};
</script>
